import services from "../service";

export default {
    register(uuid : string) {
        return services.post('/election/'+ uuid + '/register');
    },
    startVoting(code : string,hash){
        return services.post('/ga/'+code+'/election/vote/start',hash);
    },
    validateOtp(code,payload){
        return services.post('/ga/'+code+'/election',payload);
    },
    // pollVote(uuid : string ,payload: any){
    //     payload.client = 3;
    //     return services.post('/election/poll/'+uuid,payload);
    // },
    statPoll(){
        return services.post('/election/poll/stats');
    },
    submitVote(code,payload) {
        return services.post('/ga/'+code+'/election/vote', payload);
    },
    getBallot(ballot,hash:string) {
        return services.get('/election/ballot/'+ballot+'?hash='+hash);
    },
    getBOD(payload,ga_type) {
        // console.log(payload);
        return services.getbody('/ga/'+ga_type+'/election/candidates/bod',{hash:payload.hash});
    },
    getAudit(payload,ga_type) {
        return services.getbody('/ga/'+ga_type+'/election/candidates/audit',{hash:payload.hash});
    },
    getElecom(payload,ga_type) {
        return services.getbody('/ga/'+ga_type+'/election/candidates/elecom',{hash:payload.hash});
    },
    attachOtp(uuid: string,otp:string) {
        return services.put('/election/'+uuid,{otp:otp});
    },
    mockParticipate(uuid: string,payload) {
        return services.post('/election/'+uuid+'/mock',{action:payload});
    },
    getSchedule(uuid : string) {
        return services.get('/election/'+uuid);
    },
    verify(uuid : string, otp : string) {
        return services.post('/election/otp', {
            uuid: uuid,
            otp: otp,
        });
    },
    vote(uuid : string, votes : string) {
        return services.post('/election/vote', {
            uuid: uuid,
            votes: votes,
        });
    },
    resend(uuid : string) {
        return services.post('/election/otp/resend', {
            uuid: uuid,
        });
    },
    saveRemarks(payload : any) {
        return services.post('/election/remarks', payload);
    },
    getGaInfo(payload){
        // console.log(payload);
        return services.get('/ga/info',{hash:payload});
    },
    GaRegister(payload,series){
        // console.log(payload);
        return services.post('/ga/'+series+'/register', payload);
    }
}
